import { render, staticRenderFns } from "./InfluencerTrafficDataTable.vue?vue&type=template&id=48e88e78&"
import script from "./InfluencerTrafficDataTable.vue?vue&type=script&lang=js&"
export * from "./InfluencerTrafficDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports